<div
  class="relative mb-4 bg-cover bg-center pb-8 pt-6 lg:mb-8 lg:pb-16 lg:pt-12"
  style="background-image: url('assets/img/background.jpg')"
></div>
